import { CheckboxUI } from '../Interface';
import { useFormikContext } from 'formik';

const ServiceGroupLinks = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext();

  const updateServiceOperationGroupLink = (serviceGroupId, isChecked) => {
    const updatedLinks = values?.serviceOperationGroupLink?.map((link) =>
      link.id === serviceGroupId ? { ...link, checked: isChecked } : link
    );
    setFieldValue('serviceOperationGroupLink', updatedLinks);
  };

  return (
    <div>
      {values?.serviceOperationGroupLink?.map((serviceOperationGroup) => (
        <div key={serviceOperationGroup.id}>
          <CheckboxUI
            sx={{ margin: 0, padding: '0.2rem' }}
            disabled={disabled}
            onChange={(e) => updateServiceOperationGroupLink(serviceOperationGroup.id, e.target.checked)}
            checked={serviceOperationGroup.checked || false}
          />
          {serviceOperationGroup.name}
        </div>
      ))}
    </div>
  );
};

export default ServiceGroupLinks;
